import * as _ from 'underscore';

import { Component, Input } from '@angular/core';

import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DatatableV3Component } from '../datatable-v3/datatable-v3.component';

@Component({
	selector: 'app-datatable-v4',
	styleUrls: ['./datatable-v4.component.css'],
	templateUrl: './datatable-v4.component.html'
})
export class DatatableV4Component extends DatatableV3Component {
	@Input() is_card_mleft_not_required: boolean;

	public isPlatform = true;
	public platformAsc = false;
	public newTableDataNetwork: any = {};
	public newTableDataPlatform: any = {};
	public currentFieldName: string;
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.is_card_mleft_not_required = this.is_card_mleft_not_required ? this.is_card_mleft_not_required : false;
		super.ngOnInit();
	}
	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
	generateDateTableConfiguration(responseData: any): void {
		this.dataTableObj.data = this.generateResponseDataFromConfig(responseData);
		if (!this.defaultsort) {
			this.sortDataByImpressionsInDescendingOrder();
		}
		this.processDataForProgressBar(this.dataTableObj.data);
	}

	sortDataByImpressionsInDescendingOrder(): void {
		this.dataTableObj.data = _.sortBy(this.dataTableObj.data, 'impressions').reverse();
	}
	ngDoCheck(): void {
		this.newTableDataPlatform.data = this.dataTableObj.data.filter(
			(prop: { is_platform: string }) => prop.is_platform === 'true'
		);
		this.newTableDataNetwork.data = this.dataTableObj.data.filter(
			(prop: { is_platform: string }) => prop.is_platform === 'false'
		);
	}
	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.tableConfig.csvQueryKey ? this.tableConfig.csvQueryKey : this.key,
			this.tableConfig.downloadFileName
		);
	}
	toggleMode(): void {
		this.isPlatform = !this.isPlatform;
		if (this.isPlatform) {
			this.dataTableObj.columns[0].name = 'Platform';
		} else {
			this.dataTableObj.columns[0].name = 'Network';
		}
	}
	customSort(name: any): void {
		const data = JSON.parse(JSON.stringify(this.dataTableObj.data));
		const field_name = name.includes('%')
			? name.replace('%', '').split(' ')[0].toLowerCase() + '_completions_rate'
			: name.toLowerCase();
		if (this.currentFieldName === field_name) {
			this.dataTableObj.data = this.platformAsc ? _.sortBy(data, field_name).reverse() : _.sortBy(data, field_name);
			this.platformAsc = !this.platformAsc;
		} else {
			this.platformAsc = true;
			this.dataTableObj.data = _.sortBy(data, field_name);
			this.currentFieldName = field_name;
		}
	}
}
